export default function dateTimeDiff(to, from) {
  let seconds = null;
  seconds = Math.floor((from - to) / 1000);
  seconds = Math.abs(seconds);

  const intervals = [
    [31536000, "year"],
    [2592000, "month"],
    [86400, "day"],
    [3600, "hour"],
    [60, "minute"],
    [1, "second"]
  ];

  let interval = seconds;
  let intervalStrings = [];
  for (let i = 0; i < intervals.length; i++) {
    let divResult = Math.floor(interval / intervals[i][0]);
    if (divResult > 0) {
      intervalStrings.push(
        divResult + " " + intervals[i][1] + (divResult > 1 ? "s" : "")
      );
      interval = interval % intervals[i][0];
    }
  }
  return intervalStrings.join(" ");
}
